import { AppBar, Button, Dialog, Divider, IconButton, Stack, Toolbar, Typography } from "@mui/material";
import WushCard from "../../layout/WushCard";
import ItemCategoryName from "../../text/ItemCategoryName";
import { Cancel } from "@mui/icons-material";
import OrderStatusChip from "../orders/OrderStatusChip";
import ReservationDateRange from "../../text/ReservationDateRange";
import useReservationStore from "../../../stores/useReservationStore";
import update from "../../../api/auth/reservations/update";
import useAlertStore from "../../../stores/useAlertStore";
import { useState } from "react";
import ExpandedReservationCard from "./ExpandedReservationCard";

export default function ReservationCard({reservation, hideStartTime, hideEndTime}) {

  const [expanded, setExpanded] = useState(false);

  const { removeReservation } = useReservationStore();

  const { setAlertMessage } = useAlertStore();

  const handleFulfill = () => {
    update(reservation.id, { fulfillment_status: 'fulfilled' }, (response) => {
      setAlertMessage('Reservation fulfilled!', 'success');
      removeReservation(response);
    });
  };

  const handleReturn = () => {
    update(reservation.id, { return_status: 'returned' }, (response) => {
      setAlertMessage('Reservation returned!', 'success');
      removeReservation(response);
    });
  };

  const handleDialogClose = (e, reason) => {
    e.preventDefault();
    if (reason !== 'backdropClick') {
      setExpanded(false);
    }
  };

  return (
    <WushCard
      key={reservation.id}
      onClick={() => {
        setExpanded(!expanded);
      }}
    >
      <Stack p={1}>
        <Stack direction="row">
          <ItemCategoryName itemCategory={reservation.reservation_items[0].item.item_category} clickable={false} />
        </Stack>
        <Stack my={0.5}>
          <Divider />
        </Stack>
        <Stack direction="row" justifyContent="space-between">
          <Typography variant="h6">{reservation.order.customer.full_name}</Typography>
          <OrderStatusChip order={reservation.order} />
        </Stack>
        <ReservationDateRange variant="body2" fontWeight={400} reservation={reservation} hideStartTime={hideStartTime} hideEndTime={hideEndTime} />
        <Typography variant="body2"><i>{reservation.order.admin_comments}</i></Typography>
        <Typography variant="body2"><i>{reservation.admin_comments}</i></Typography>
        <Stack direction="row" justifyContent="space-between">
          <Typography variant="body2">{reservation.reservation_items[0].quantity}x {reservation.reservation_items[0].item.name} ({reservation.bookable_duration.name}) {reservation.reservation_items.length > 1 && `and ${reservation.reservation_items.length - 1} other items`}</Typography>
          <Typography variant="body2">${reservation.order.total_revenue_dollars} / ${reservation.order.grand_total_price_dollars}</Typography>
        </Stack>
      </Stack>
      <Stack>
        <Dialog
          open={expanded}
          onClose={handleDialogClose}
          fullWidth
        >
          <AppBar color="grey" sx={{ position: 'relative' }}>
            <Toolbar>
              <Stack mr={2}>
                <Typography variant="h6">
                  Reservation Details
                </Typography>
              </Stack>
              <IconButton size="large" sx={{ ml: 'auto !important'}}>
                <Cancel fontSize="50px"/>
              </IconButton>
            </Toolbar>
          </AppBar>
          <Stack p={2} spacing={2}>
            <Stack>
              {reservation.fulfillment_status === 'unfulfilled' ?
                <Button onClick={handleFulfill} variant="contained" color="primary">Mark Fulfilled</Button>
                :
                <Button onClick={handleReturn} variant="contained" color="primary">Mark Returned</Button>
              }
            </Stack>
            <ExpandedReservationCard reservation={reservation} hideStartTime={hideStartTime} hideEndTime={hideEndTime} />
          </Stack>
        </Dialog>
      </Stack>
    </WushCard>
  );
}